/**
 * Announcement V2 API Service
 * Handles async announcement email sending with progress tracking
 */
import httpService from 'services/httpService.js';
import { store } from 'Store';

const getUser = () => {
  const state = store.getState();
  return state.userInfo;
};

/**
 * Create announcement with async email sending (V2)
 * Email notification is controlled by course settings (announcement_notification)
 */
export const createAnnouncementAsync = async (courseId, data) => {
  const user = getUser();
  const formData = new FormData();
  formData.append('title', data.title || '');
  formData.append('description', data.description);

  const response = await httpService.instance({
    method: 'post',
    url: `/announcements/api/announcement/${courseId}/create_announcement_async/?format=json`,
    data: formData,
    headers: {
      Authorization: `Token ${user.token}`,
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

/**
 * Get what publishing would do: whether emails will be sent and to how many
 */
export const getAnnouncementPreviewInfo = async (courseId) => {
  const user = getUser();
  const response = await httpService.get(
    `/announcements/api/announcement/${courseId}/announcement_preview_info/`,
    { headers: { Authorization: `Token ${user.token}` } }
  );
  return response.data;
};

/**
 * Get email task progress
 */
export const getEmailTaskProgress = async (courseId, taskId) => {
  const user = getUser();
  const response = await httpService.get(
    `/announcements/api/announcement/${courseId}/announcement_email_progress/${taskId}/`,
    { headers: { Authorization: `Token ${user.token}` } }
  );
  return response.data;
};

/**
 * Check for active email task
 */
export const getActiveEmailTask = async (courseId) => {
  const user = getUser();
  const response = await httpService.get(
    `/announcements/api/announcement/${courseId}/active_announcement_email_task/`,
    { headers: { Authorization: `Token ${user.token}` } }
  );
  return response.data;
};

export default {
  createAnnouncementAsync,
  getAnnouncementPreviewInfo,
  getEmailTaskProgress,
  getActiveEmailTask,
};
